import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "Redux/Actions/actionTypes";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import ApplicationSearchRequest from "../../Communication/ApiClasses/ApplicationSearchRequest";

// worker
function* handleApplicationSearch(action) {
  yield put(doLoadingStart(actionTypes.APPLICATION_SEARCH));

  const applicationSearchRequest = new ApplicationSearchRequest(action.data);
  try {
    const result = yield call(applicationSearchRequest.getData);
    yield put({
      type: `${actionTypes.APPLICATION_SEARCH}_SUCCESS`,
      response: result.data,
    });
    yield call(action.callback, result);
  } catch (error) {
    yield put({
      type: `${actionTypes.APPLICATION_SEARCH}_ERROR`,
      error,
    });
    yield call(action.callback, { error });
  } finally {
    yield put(doLoadingFinish(actionTypes.APPLICATION_SEARCH));
  }
}

// watcher
export default function* applicationSearchSaga() {
  yield takeLatest(actionTypes.APPLICATION_SEARCH, handleApplicationSearch);
}
